import { useEffect } from 'react';

import { fetchMainCurrencies, useMainCurrenciesState } from '../index.js';

export const useFetchMainCurrencies = () => {
  const [, setMainCurrenciesState] = useMainCurrenciesState();

  useEffect(() => {
    fetchMainCurrencies().then((data) => setMainCurrenciesState(data));
  }, []);
};
